import React, { useState } from "react";
import classNames from "classnames";
import "./Checkbox.scss";

const Checkbox = ({
  checked,
  label,
  expandedLabel,
  expands = false,
  moreLabel,
  indeterminate = false,
  onClick,
  errorMessage,
  className,
  labelClassName,
  required = false
}) => {
  const [expanded, setExpanded] = useState(false);

  const displayLabel =
    expands && expanded && expandedLabel ? expandedLabel : label;

  const expand = event => {
    event.stopPropagation();
    event.preventDefault();
    setExpanded(true);
  };

  const toggleFromLabel = event => {
    if (event.target.closest("a, button")) {
      return;
    }
    onClick();
  };

  const requiredMark = required ? (
    <span className="text-red-1 font-semibold mr-1" aria-hidden="true">
      *
    </span>
  ) : null;

  const checkMark = (
    <div
      className={classNames("check", {
        check_indeterminate: checked && indeterminate,
        check_checked: checked && !indeterminate,
        check_unchecked: !checked
      })}
    />
  );

  if (expands) {
    return (
      <div>
        <div
          className={classNames(
            "lp_checkbox font-medium text-sm py-1 flex gap-2 px-0 text-black text-left",
            className
          )}
        >
          <button
            type="button"
            onClick={onClick}
            className={"lp_checkbox__control"}
            aria-pressed={!!checked}
          >
            {checkMark}
          </button>
          <span
            className={classNames(
              "lp_checkbox__label lp_checkbox__label--clickable",
              labelClassName
            )}
            onClick={toggleFromLabel}
            onKeyDown={event => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                toggleFromLabel(event);
              }
            }}
            role="button"
            tabIndex={0}
          >
            {requiredMark}
            <span dangerouslySetInnerHTML={{ __html: displayLabel }} />
            {!expanded && moreLabel ? (
              <>
                {" "}
                <button
                  type="button"
                  className={classNames("lp_checkbox__more", labelClassName)}
                  onClick={expand}
                >
                  {moreLabel}
                </button>
              </>
            ) : null}
          </span>
        </div>
        {errorMessage ? (
          <span className={"font-medium text-xs flex gap-2 px-0 text-red-1"}>
            {errorMessage}
          </span>
        ) : null}
      </div>
    );
  }

  return (
    <div>
      <button
        type="button"
        onClick={onClick}
        className={classNames(
          "lp_checkbox font-medium text-sm py-1 flex gap-2 px-0 text-black text-left",
          className
        )}
      >
        {checkMark}
        <span className={classNames("lp_checkbox__label", labelClassName)}>
          {requiredMark}
          <span dangerouslySetInnerHTML={{ __html: displayLabel }} />
        </span>
      </button>
      {errorMessage ? (
        <span className={"font-medium text-xs flex gap-2 px-0 text-red-1"}>
          {errorMessage}
        </span>
      ) : null}
    </div>
  );
};

export default Checkbox;
